<div
  *ngIf="photos.length; else noPhoto"
  #strip
  class="relative flex h-full snap-x snap-mandatory overflow-x-auto overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
  (scroll)="onScroll(strip)"
>
  <ng-container *ngFor="let photo of photos; let i = index">
    <a *ngIf="link; else plain" [routerLink]="link" tabindex="-1" aria-hidden="true" class="relative h-full w-full shrink-0 snap-start">
      <ng-container *ngTemplateOutlet="image; context: { $implicit: photo, i: i }"></ng-container>
    </a>
    <ng-template #plain>
      <div class="relative h-full w-full shrink-0 snap-start" [class.cursor-pointer]="tappable" (click)="photoTap.emit(i)">
        <ng-container *ngTemplateOutlet="image; context: { $implicit: photo, i: i }"></ng-container>
      </div>
    </ng-template>
  </ng-container>
</div>

<ng-template #image let-photo let-i="i">
  <img
    *ngIf="!failed.has(i); else broken"
    [src]="photo.src"
    [attr.srcset]="photo.srcset"
    [attr.sizes]="sizes"
    [alt]="alt + ', photo ' + (i + 1)"
    [attr.loading]="i === 0 ? null : 'lazy'"
    decoding="async"
    class="absolute inset-0 h-full w-full object-cover"
    (error)="failed.add(i)"
  />
  <ng-template #broken>
    <span class="absolute inset-0 flex items-center justify-center text-primary/30" aria-hidden="true">
      <mat-icon class="!h-12 !w-12 !text-5xl">{{ placeholderIcon }}</mat-icon>
    </span>
  </ng-template>
</ng-template>

<ng-template #noPhoto>
  <div class="absolute inset-0 flex items-center justify-center text-primary/30" aria-hidden="true">
    <mat-icon class="!h-12 !w-12 !text-5xl">{{ placeholderIcon }}</mat-icon>
  </div>
</ng-template>

<!-- With more than one: where you are, and arrows for a mouse (a phone swipes) -->
<ng-container *ngIf="photos.length > 1">
  <span class="pointer-events-none absolute bottom-2 left-2 rounded-full bg-black/60 px-2 py-0.5 text-xs font-medium tabular-nums text-white"
    [attr.aria-label]="'Photo ' + (index + 1) + ' of ' + photos.length">
    {{ index + 1 }}/{{ photos.length }}
  </span>
  <button *ngIf="index > 0" type="button" (click)="show(index - 1)" aria-label="Previous photo"
    class="absolute left-2 top-1/2 h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-primary shadow-sm transition hover:bg-white focus-visible:flex focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
    [ngClass]="arrows === 'always' ? 'flex' : 'hidden group-hover:flex'">
    <mat-icon class="!h-auto !w-auto !text-xl">chevron_left</mat-icon>
  </button>
  <button *ngIf="index < photos.length - 1" type="button" (click)="show(index + 1)" aria-label="Next photo"
    class="absolute right-2 top-1/2 h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-primary shadow-sm transition hover:bg-white focus-visible:flex focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
    [ngClass]="arrows === 'always' ? 'flex' : 'hidden group-hover:flex'">
    <mat-icon class="!h-auto !w-auto !text-xl">chevron_right</mat-icon>
  </button>
</ng-container>
